import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Poster from "../Poster/Poster";
import Deal from "../Deal/Deal";
import IB from "../IB/IB";
import DestinationOffer from "../DestinationOffer/DestinationOffer";
import WhyAbc from "../WhyAbc/WhyAbc";
import WhyChoose from "../WhyChoose/WhyChoose";
import Marq from "../Marq/Marq";

const Home = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("/#h-fh", "");

      const scrollToElement = () => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
        } else {
          requestAnimationFrame(scrollToElement);
        }
      };

      scrollToElement();
    }
  }, [location]);

  return (
    <>
      <Poster />
      <Marq/>
      <Deal /> {/* 🔑 ID h-fh is inside this */}
      <IB />
      <DestinationOffer />
      <WhyChoose />
    </>
  );
};

export default Home;
